import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { arrayOf, object, func } from 'prop-types'
import { chunk } from 'lodash'

import './Menu.scss'

class HoverMenu extends Component {
  state = {
    openLevel2: false,
    height: 590,
    activePriority: 1,
  }

  mouseEnter = (priority) => {
    const height = document.getElementById('hoverHeight').clientHeight
    this.setState({
      openLevel2: true,
      height,
      activePriority: priority,
    })
  }

  mouseEnterChild = (priority) => {
    this.setState({
      openLevel2: true,
      activePriority: priority,
    })
  }

  mouseLeave = () => {
    this.setState({
      openLevel2: false,
      activePriority: 0,
    })
  }

  partialLeave = () => {
    if (!this.state.openLevel2) {
      this.props.onMouseLeave()
    }
  }

  totalLeave = () => {
    this.mouseLeave()
    this.props.onMouseLeave()
  }

  generateLevel1 = data =>
    chunk(data, 3).map((item, index) => (
      <li
        key={[`hover-priority-${index + 1}`]}
        className={index + 1 === this.state.activePriority ? 'active' : ''}
        onMouseEnter={() => this.mouseEnter(index + 1)}
        onMouseLeave={this.mouseLeave}>
        <ul className='list-unstyled list-inline sublevel1'>
          {item.map((res, idx) => (
            <li key={[`level1-menu-${idx}`]}>
              <Link onClick={this.props.onMouseLeave} to={`/c/${res.slug_url}`}>
                {res.name}
              </Link>
              <span className='divider'>•</span>
            </li>
          ))}
        </ul>
        <div className='overlap' />
      </li>
    ))

  generateLevel2 = (data, activePriority, banners) => (
    <div
      className='hover__right clearfix'
      onMouseEnter={() => this.mouseEnterChild(activePriority)}
      onMouseLeave={this.mouseLeave}
      style={{ height: this.state.height }}>
      <div className='hover__right__content'>
        {data.map((res, index) => (
          <div
            key={[`level1-menu-${index}`]}
            className={data.length > 1 ? 'hover__half__level2' : 'hover__full__level2'}>
            <div className='hover__content__header'>
              <Link onClick={this.props.onMouseLeave} to={`/c/${res.slug_url}`}>
                {res.name}
              </Link>
            </div>
            {res.children &&
              res.children.length > 0 &&
              res.children.map((res2, index2) => (
                <div key={[`level2-menu-${index2}`]} className='hover__content'>
                  <div className='hover__level2__title'>
                    <Link
                      onClick={this.props.onMouseLeave}
                      to={`/c/${res.slug_url}/${res2.slug}`}>
                      {res2.name}
                    </Link>
                  </div>
                  <ul className='list-unstyled'>
                    {res2.children &&
                      res2.children.length > 0 &&
                      res2.children.map((res3, index3) => (
                        <li key={[`level3-menu-${index3}`]}>
                          <Link onClick={this.props.onMouseLeave} to={`/c/${res.slug_url}/${res2.slug}/${res3.slug}`}>
                            {res3.name}
                          </Link>
                        </li>
                      ))}
                  </ul>
                </div>
              ))}
          </div>
        ))}
      </div>
      <div className='hover__right__promo'>
        {
          banners && banners.length > 0 && banners.map(banner => (
            <img key={banner.imageUrl} src={banner.imageUrl} className='img__full' alt={banner.name} />
          ))
        }
      </div>
    </div>
  )

  render() {
    const { data, banners } = this.props
    const level1 = data && this.generateLevel1(data)
    const chunkData = chunk(data, 3)
    return (
      <div className='hover__menu clearfix'>
        <div className='hover__header' />
        <div className='hover__content clearfix' onMouseLeave={this.totalLeave}>
          <div className='hover__left' onMouseLeave={this.partialLeave} id='hoverHeight'>
            <ul className='list-unstyled level1'>{level1}</ul>
          </div>
          {data &&
            this.state.openLevel2 &&
            this.state.activePriority > 0 &&
            this.generateLevel2(chunkData[this.state.activePriority - 1], this.state.activePriority, banners)}
        </div>
      </div>
    )
  }
}

HoverMenu.defaultProps = {
  data: [],
  banners: [],
}

HoverMenu.propTypes = {
  data: arrayOf(object),
  banners: arrayOf(object),
  onMouseLeave: func.isRequired,
}

const mapStateToProps = () => ({})
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      //
    },
    dispatch,
  )

export default connect(mapStateToProps, mapDispatchToProps)(HoverMenu)



// WEBPACK FOOTER //
// ./src/common/Menu/HoverMenu.js